import React from "react";
import Nav from "react-bootstrap/Nav";
import { Link, useNavigate } from "react-router-dom";
import { usePermissions } from "../../hooks/usePermissions";

const APP_NAV_ITEMS = [
  { path: "/apps/activitylog", label: "Activity Log", icon: "bi-activity", eventKey: "activityLog", permissionKey: "home.apps-portal" },
  { path: "/apps/taskmanager", label: "Task Manager", icon: "bi-bar-chart-fill", eventKey: "taskManager", permissionKey: "home.apps-portal", desktopOnly: true },
  { path: "/apps/bookingslog", label: "Bookings Log", icon: "bi-calendar-check", eventKey: "bookingslog", permissionKey: "apps.bookings-log" },
  { path: "/apps/salesTargets", label: "Sales Targets", icon: "bi-target", eventKey: "salesTargets", permissionKey: "apps.sales-targets" },
];

function AppsNav({ keyValue }) {
  const navigate = useNavigate();
  const { canView, isLoading } = usePermissions();
  const visibleItems = isLoading
    ? []
    : APP_NAV_ITEMS.filter((item) => canView(item.permissionKey));

  const handleHomeClick = (e) => {
    e.preventDefault();
    navigate("/");
  };

  return (
    <div className="modern-nav-container">
      <Nav variant="tabs" activeKey={keyValue} className="modern-nav apps-nav">
        <Nav.Item>
          <Nav.Link 
            onClick={handleHomeClick}
            className="modern-nav-link home-nav-link"
          >
            <i className="bi bi-house-fill me-2"></i>
            Home
          </Nav.Link>
        </Nav.Item>
        {visibleItems.map((item) => (
          <Nav.Item key={item.path} className={item.desktopOnly ? "d-none d-md-block" : undefined}>
            <Nav.Link
              as={Link}
              to={item.path}
              className="modern-nav-link"
              eventKey={item.eventKey}
            >
              <i className={`bi ${item.icon} me-2`}></i>
              {item.label}
            </Nav.Link>
          </Nav.Item>
        ))}
      </Nav>
    </div>
  );
}

export default AppsNav;
